import {
  Svg,
  Defs,
  RadialGradient,
  Stop,
  Polygon,
  Circle,
  Text as SvgText,
  G,
} from '@react-pdf/renderer';

// 24-pointed starburst points from the approved mockup
const STARBURST_POINTS = `
  50,0 54,15 58,3 60,18 67,5 66,20 75,10 72,24 82,17 77,29
  88,25 82,35 95,33 86,42 100,43 90,50
  100,57 86,58 95,67 82,65 88,75 77,71
  82,83 72,76 75,90 66,80 67,95 60,82
  58,97 54,85 50,100
  46,85 42,97 40,82 33,95 34,80 25,90 28,76
  18,83 23,71 12,75 18,65 5,67 14,58 0,57 10,50
  0,43 14,42 5,33 18,35 12,25 23,29
  18,17 28,24 25,10 34,20 33,5 40,18 42,3 46,15
`.replace(/\s+/g, ' ').trim();

interface GoldStarburstSealProps {
  size?: number;
}

export function GoldStarburstSeal({ size = 130 }: GoldStarburstSealProps) {
  return (
    <Svg viewBox="0 0 100 100" style={{ width: size, height: size }}>
      <Defs>
        {/* Gold radial gradient for 3D effect */}
        <RadialGradient id="goldGradient" cx="30%" cy="30%" r="70%">
          <Stop offset="0%" stopColor="#FFD700" />
          <Stop offset="40%" stopColor="#DAA520" />
          <Stop offset="70%" stopColor="#B8860B" />
          <Stop offset="100%" stopColor="#8B6914" />
        </RadialGradient>
        {/* Inner circle gold gradient */}
        <RadialGradient id="innerGoldGradient" cx="30%" cy="30%" r="70%">
          <Stop offset="0%" stopColor="#FFDF00" />
          <Stop offset="50%" stopColor="#D4AF37" />
          <Stop offset="100%" stopColor="#996515" />
        </RadialGradient>
      </Defs>

      {/* 24-pointed starburst */}
      <Polygon points={STARBURST_POINTS} fill="url(#goldGradient)" />

      {/* Inner circle with embossed effect */}
      <Circle
        cx="50"
        cy="50"
        r="35"
        fill="url(#innerGoldGradient)"
        stroke="#8B6914"
        strokeWidth={1}
      />
      {/* Inner highlight ring for embossed effect */}
      <Circle
        cx="50"
        cy="50"
        r="32"
        fill="none"
        stroke="rgba(255,255,255,0.25)"
        strokeWidth={0.5}
      />

      {/* Seal text - "DITAN" and "ATTORNEY'S" centered */}
      <G>
        <SvgText
          x="50"
          y="46"
          textAnchor="middle"
          style={{
            fontSize: 10,
            fontFamily: 'Helvetica-Bold',
            fill: '#4A3000',
          }}
        >
          DITAN
        </SvgText>
        <SvgText
          x="50"
          y="58"
          textAnchor="middle"
          style={{
            fontSize: 8,
            fontFamily: 'Helvetica-Bold',
            fill: '#4A3000',
          }}
        >
          ATTORNEY'S
        </SvgText>
      </G>
    </Svg>
  );
}

// Fallback: Simple gold seal without gradients (if RadialGradient doesn't work)
export function GoldStarburstSealSimple({ size = 130 }: GoldStarburstSealProps) {
  return (
    <Svg viewBox="0 0 100 100" style={{ width: size, height: size }}>
      {/* 24-pointed starburst with solid gold */}
      <Polygon points={STARBURST_POINTS} fill="#DAA520" />

      {/* Inner circle */}
      <Circle
        cx="50"
        cy="50"
        r="35"
        fill="#D4AF37"
        stroke="#8B6914"
        strokeWidth={2}
      />
      {/* Inner highlight ring */}
      <Circle
        cx="50"
        cy="50"
        r="32"
        fill="none"
        stroke="#FFD700"
        strokeWidth={1}
      />

      {/* Seal text */}
      <G>
        <SvgText
          x="50"
          y="46"
          textAnchor="middle"
          style={{
            fontSize: 10,
            fontFamily: 'Helvetica-Bold',
            fill: '#4A3000',
          }}
        >
          DITAN
        </SvgText>
        <SvgText
          x="50"
          y="58"
          textAnchor="middle"
          style={{
            fontSize: 8,
            fontFamily: 'Helvetica-Bold',
            fill: '#4A3000',
          }}
        >
          ATTORNEY'S
        </SvgText>
      </G>
    </Svg>
  );
}
